
import * as defaultImport from "@splunk/dashboard-icons";
export * from "@splunk/dashboard-icons";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
